<section class="w-100">
  <div class="d-flex flex-row modal-header-container">
    <div class="col-3 pl-0 m-auto d-flex flex-column">
      <span class="title my-auto">{{ pages[currentPage]?.label | translate }}</span>

      <span class="form-subheader-message my-auto">{{ subtitles[currentPage]?.label | translate }}</span>
    </div>
    <div class="stepper-container col-9">
      <ng-container *ngFor="let page of pages; let i = index">
        <div class="outer-circle" [ngClass]="{ enabled: i <= currentPage }">
          <div class="inner-circle">
            <span class="inner-text">
              <span class="inline">{{ page.icon }}</span>
              <span class="inner-label"> {{ page.label | translate }}</span>
            </span>
          </div>
        </div>

        <div class="progress-bar-container" *ngIf="i !== pages.length - 1">
          <ngb-progressbar
            type="success"
            [value]="i < currentPage ? 100 : 0"
            striped="true"
            height=".65rem"
          ></ngb-progressbar>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-content></ng-content>

  <div class="col-12 mt-3 pb-1 d-flex modal-buttons-container justify-content-between">
    <div class="my-auto">
      <button
        (click)="onClickBackButton()"
        class="btn btn-outline-secondary btn-big previous mr-auto"
        type="button"
        *ngIf="currentPage != 0"
      >
        {{ 'generic.back' | translate }} ({{ pages[currentPage - 1]?.label || 'generic.back' | translate }})
      </button>
    </div>

    <div class="d-flex flex-row">
      <div class="my-auto">
        <ng-content select="[customButton]"></ng-content>
      </div>

      <div class="my-auto">
        <button
          (click)="onClickNextButton()"
          class="btn btn-secondary next btn-big"
          type="button"
          *ngIf="currentPage !== pages.length - 1; else submitButton"
          [disabled]="!disableNavigationWhenInvalid ? false : !valid"
        >
          {{ 'generic.continue' | translate }} ({{ pages[currentPage + 1]?.label || 'generic.next' | translate }})
        </button>
      </div>
    </div>
  </div>
</section>

<ng-template #submitButton>
  <button (click)="onClickSubmit()" class="btn btn-secondary btn-big" type="button">
    {{ 'generic.continue' | translate }} ({{ 'generic.submit' | translate }})
  </button>
</ng-template>
